export enum LicenseWiseSecurityRoles {
    onlyInformate = 1,
    onlyIdms = 2,
    idmsInformate = 3,
}
